import axios, { AxiosRequestConfig } from 'axios';
import CONFIG from '@config/';
import HTTPHeaderController from '@function/auth/authorization';
import { reissueToken } from '../function/auth/token';
import TokenController from '@function/auth/tokenStorage';

const instance = axios.create({
  baseURL: CONFIG.API_URL,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json',
  },
  maxRedirects: 5,
});

const clientHeader = new HTTPHeaderController(instance);

instance.interceptors.request.use((request: AxiosRequestConfig) => {
  request.headers = request.headers ?? {};
  const token = TokenController.get();
  if (token?.access_token) {
    request.headers.Authorization = `Bearer ${token.access_token}`;
  }
  return request;
});

const BAD_AUTH_CODE = [401, 422];

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    error.headers = error.headers ?? {};
    const errorCode = error.response?.status ?? 0;
    if (!BAD_AUTH_CODE.includes(errorCode)) return Promise.reject(error);

    try {
      const token = TokenController.get();
      if (token) {
        const newToken = await reissueToken(token);
        clientHeader.setAuth(newToken.access_token);
        error.config.headers.Authorization = `Bearer ${newToken.access_token}`;
        return instance.request(error.config);
      }
    } catch (e) {
      console.error('[reissueToken] failed:', e);
    }

    clientHeader.clearAuth();
    TokenController.remove();
    return Promise.reject(error);
  }
);

export default instance;
